var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0.5C13.016 0.5 0.5 13.016 0.5 28.5C0.5 43.984 13.016 56.5 28.5 56.5C43.984 56.5 56.5 43.984 56.5 28.5C56.5 13.016 43.984 0.5 28.5 0.5ZM28.5 50.9C16.152 50.9 6.1 40.848 6.1 28.5C6.1 16.152 16.152 6.1 28.5 6.1C40.848 6.1 50.9 16.152 50.9 28.5C50.9 40.848 40.848 50.9 28.5 50.9ZM40.526 16.474C39.4358 15.3838 37.6682 15.3838 36.578 16.474L28.5 24.552L20.422 16.474C19.3318 15.3838 17.5642 15.3838 16.474 16.474C15.3838 17.5642 15.3838 19.3318 16.474 20.422L24.552 28.5L16.474 36.578C15.3838 37.6682 15.3838 39.4358 16.474 40.526C17.5642 41.6162 19.3318 41.6162 20.422 40.526L28.5 32.448L36.578 40.526C37.6682 41.6162 39.4358 41.6162 40.526 40.526C41.6162 39.4358 41.6162 37.6682 40.526 36.578L32.448 28.5L40.526 20.422C41.6162 19.3318 41.6162 17.5642 40.526 16.474Z",
    fill: "#E7514F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.2306bbb81dcf62df943c3a2d913a39ff.svg";
export { ForwardRef as ReactComponent };